import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchAssetDetail = createAsyncThunk("fetchAssetDetail", async ({ id }) => {
	const response = await axiosHttp.get(`assets/${id}`);
	return response.data?.data ?? response.data;
});

const AssetDetailSlice = createSlice({
	name: "assetDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetStateAssetDetail: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchAssetDetail.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchAssetDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchAssetDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStateAssetDetail } = AssetDetailSlice.actions;
export default AssetDetailSlice.reducer;
